import React from 'react'
import NavLink from '../../../components/util/lgy-nav-link/LgyNavLink'
import { FaExclamationTriangle } from 'react-icons/fa'

const ProfileNav = ({ isAffiliate, location, match, user }) =>
  <div className='sidenav sticky'>
    <ul className='usa-sidenav-list profile-nav'>
      <li>
        <NavLink activeClassName={location.pathname === match.url ? 'usa-current' : ''} to={`${match.url}`}>
          My Profile
      </NavLink>
      </li>
      <li>
        <NavLink activeClassName='usa-current' to={`${match.url}/contact`}>
          Contact Information
      </NavLink>
      </li>
      {isAffiliate && <li>
        <NavLink activeClassName='usa-current' to={`${match.url}/affiliation`}>
          {console.log('length is ', user.affiliations.length)}
          Affiliate Information {user.affiliations.length === 0 && <span><FaExclamationTriangle color='orangered' />(Missing affiliations)</span>}
        </NavLink>
      </li>}
    </ul>
  </div>

export default ProfileNav
